import React from "react";
import { Box, Button, Flex, Heading, HStack, Spacer } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { AccordionItem } from "components";
import { Agreement, Emergency, Medication, Regional } from "./components";

const Calculation: React.FC = () => (
  <Box>
    <HStack mt={6}>
      <Heading as="h3" color="black" fontSize="lg" lineHeight="7">
        Protocols
      </Heading>
      <Spacer />
      <Button as={Link} to="anesthetic-protocols">
        Add Protocol
      </Button>
    </HStack>

    <Flex mt={6} direction="column" gap={6}>
      <AccordionItem title="Medication Calculations">
        <Medication />
      </AccordionItem>
      <AccordionItem
        title="CPR Emergency Drugs and Doses"
        defaultExpanded={false}
      >
        <Emergency />
      </AccordionItem>
      <AccordionItem title="Regional Blocks" defaultExpanded={false}>
        <Regional />
      </AccordionItem>
      <Agreement />
    </Flex>
  </Box>
);

export default Calculation;
